import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "./client";
import type { FeedbackCreate, Feedback } from "../../types";

export function useFeedbackApi() {
  const { getToken } = useAuth();
  const api = createApiClient(() => getToken());

  return {
    async createFeedback(feedback: FeedbackCreate): Promise<Feedback> {
      const response = await api.post("/feedback", feedback);
      return response.data;
    },

    async getFeedback(id: number): Promise<Feedback> {
      const response = await api.get(`/feedback/${id}`);
      return response.data;
    },

    async updateFeedback(
      id: number, 
      updates: Partial<FeedbackCreate>
    ): Promise<Feedback> {
      const response = await api.put(`/feedback/${id}`, updates);
      return response.data;
    },

    async deleteFeedback(id: number): Promise<void> {
      await api.delete(`/feedback/${id}`);
    },

    async getFeedbackBySearch(searchId: number): Promise<Feedback[]> {
      const response = await api.get(`/feedback/search/${searchId}`);
      return response.data;
    }
  };
}
